import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { totalUsersSelector, visibleUsersSelector } from '../selectors/userSelectors';
import ListFooter from '../../shared/components/ListFooter/ListFooter';

const mapStateToProps = createStructuredSelector({
    visible: visibleUsersSelector,
    total: totalUsersSelector
});

export default connect(mapStateToProps)(ListFooter);
